import jsPDF from "jspdf";
import "jspdf-autotable";
import * as style from './ReportStyle'
import * as table from './TableData'
import { currentDate_dmy, CurrentTime } from "../../../../components/Common/CommonFunction";



var pageHeder = function (doc, data) {
    style.pageHeder1(doc, data);
    style.reportHeder1(doc, data);
    style.reportHeder2(doc, data);
    style.reportHeder3(doc, data);

};


const ManagerSummaryReport = (tableData) => {


    let data = [tableData]

    function generatePDF() {

        const doc = new jsPDF('p', 'pt', 'a4');
        const margin = {
            left: 30,
            right: 26,
            top: 63,
            bottom: 10,
        };

        const printWidth = doc.internal.pageSize.width - (margin.left + margin.right);
        const sections = 2;  // Number of sections per page
        const spacing = 5;
        const sectionWidth = (printWidth - ((sections - 1) * spacing)) / sections;

        // Iterate over each data set (or table) to be printed
        data.forEach((tableData, tableIndex) => {
            let i = {
                SAPOrderNo: tableData?.SAPOrderNo || "", // Default to an empty string if null or undefined
                FullOrderNumber: tableData?.FullOrderNumber || "", // Default to an empty string if null or undefined
            };

            if (i.SAPOrderNo) {
                var numb = i.SAPOrderNo.match(/\d/g);
                i.SAPOrderNo = numb ? numb.join("") : ""; // Join digits if found, else default to an empty string
            }

            tableData["FullOrderNumber"] = i.SAPOrderNo
                ? `${i.FullOrderNumber} (${i.SAPOrderNo})`
                : i.FullOrderNumber; // If SAPOrderNo is empty, show only FullOrderNumber



            if (tableIndex >= 0) {
                doc.addPage();
            }

            pageHeder(doc, tableData);

            const tableTopMargin = tableData?.initial_y || margin.top;
            const lastTablePosition = tableTopMargin;
            let startY = lastTablePosition;
            let currentSection = 1;
            let nextSection = 1;


            const headerHeight = 90;

            doc.autoTable({
                theme: 'grid',
                showHead: 'everyPage',
                head: [table.columns_1],
                body: table.Rows_1(tableData[0]),
                tableWidth: sectionWidth,
                startY: headerHeight + 12,


                headerStyles: {
                    cellPadding: 3,
                    lineWidth: 0.8,
                    valign: 'top',
                    fontStyle: 'bold',
                    halign: 'center',
                    fillColor: "white",
                    textColor: [0, 0, 0],
                    fontSize: 7,
                    rowHeight: 10,
                    lineColor: "black"
                },
                bodyStyles: {
                    columnWidth: 'wrap',
                    textColor: [30, 30, 30],
                    cellPadding: 3,
                    fontSize: 8,
                    lineColor: [6, 3, 1]
                },
                columnStyles: {
                    0: {
                        valign: "top",
                        columnWidth: 110
                    },
                    1: {
                        halign: 'right',
                        columnWidth: 80
                    },
                    2: {
                        halign: 'right',
                        columnWidth: 100
                    },
                    3: {
                        halign: 'right',
                        columnWidth: 60
                    },
                    4: {
                        halign: 'right',
                        columnWidth: 62
                    },
                    5: {
                        halign: 'right',
                        columnWidth: 63
                    },
                    6: {
                        halign: 'right',
                        columnWidth: 65
                    },

                    7: {
                        halign: 'right',
                        columnWidth: 65
                    },

                },


                margin: {
                    left: margin.left + ((nextSection - 1) * (sectionWidth + spacing)),
                    top: tableTopMargin,
                    bottom: margin.bottom,
                },

                rowPageBreak: 'avoid',


                didParseCell: (data1) => {


                    if (data1.row.cells[0].raw === "Order Total") {
                        data1.row.cells[0].styles.fontSize = 8;
                        data1.row.cells[0].styles.fontStyle = "bold";

                        data1.row.cells[1].styles.fontSize = 8;
                        data1.row.cells[1].styles.fontStyle = "bold";

                        data1.row.cells[2].styles.fontSize = 8;
                        data1.row.cells[2].styles.fontStyle = "bold";
                    }


                    if (data1.row.cells[3].raw === "Blank") {
                        data1.row.cells[2].colSpan = 2;
                        data1.row.cells[0].styles.fontSize = 8;
                        data1.row.cells[0].styles.fontStyle = "bold";
                    }

                    if (data1.row.cells[0].raw === "Order") {
                        data1.row.cells[0].colSpan = 4;
                        data1.row.cells[0].styles.fontSize = 8;
                        data1.row.cells[0].styles.fontStyle = "bold";
                    }


                    if (data1.row.cells[3].raw === "Total Amount") {
                        data1.row.cells[2].colSpan = 2;
                    }

                    if (data1.row.cells[1].raw === "Date") {
                        data1.row.cells[0].colSpan = 3;
                        data1.row.cells[0].styles.fontSize = 8;
                        data1.row.cells[0].styles.fontStyle = "bold";
                    }


                    const boldHeaders = [
                        "Payment Mode1",
                        "Payment Mode1 Amount",
                        "Payment Mode2",
                        "Payment Mode2 Amount"
                    ];

                    if (boldHeaders.includes(data1.cell.raw)) {
                        data1.cell.styles.fontStyle = "bold";
                        data1.cell.styles.fontSize = 7;
                        data1.cell.styles.halign = "center";
                    }



                    // ---- ORDER PAYMENT MODE TOTAL FULL-SPAN ----
                    if (data1.row.cells[0].raw === "Order Payment Mode Total") {


                        data1.row.cells[0].colSpan = 8;


                        Object.keys(data1.row.cells).forEach((key, index) => {
                            if (index > 0) {
                                data1.row.cells[key].hidden = true;
                            }
                        });

                        // Style
                        data1.row.cells[0].styles.halign = "center";
                        data1.row.cells[0].styles.fontStyle = "bold";
                        data1.row.cells[0].styles.fontSize = 8;
                        data1.row.cells[0].styles.fillColor = [230, 230, 230];
                    }
                    // FULL SPAN EMPTY ROW between Order & Invoice
                    if (data1.row.cells[0]?.raw === "___BLANK_FULL_ROW___") {

                        // span across all 8 columns
                        data1.row.cells[0].colSpan = 8;

                        // hide remaining cells
                        Object.keys(data1.row.cells).forEach((k, i) => {
                            if (i > 0) {
                                data1.row.cells[k].hidden = true;
                            }
                        });

                        // height increase for spacing
                        data1.row.height = 20;

                        // remove text & border style
                        data1.row.cells[0].text = "";
                        data1.row.cells[0].styles.fillColor = false;
                        data1.row.cells[0].styles.lineWidth = 0;
                    }
                    if (
                        data1.section === "body" &&
                        typeof data1.cell.raw === "string" &&
                        data1.cell.raw.includes("=")   // summary format check
                    ) {
                        data1.cell.colSpan = 8;                     // FULL width
                        data1.cell.styles.fontSize = 8;
                        data1.cell.styles.fontStyle = "bold";
                        data1.cell.styles.halign = "left";
                        data1.cell.styles.cellPadding = 3;
                    
                        data1.row.height = 12;                      // slim row
                    }
                    





                },


            });

            let nextStartY = doc.lastAutoTable.finalY + 10;

            doc.autoTable({
                theme: 'grid',
                showHead: 'everyPage',
                head: [table.columns_2],
                startY: nextStartY,
                body: table.Row_2(tableData[0]),
                tableWidth: sectionWidth,


                headerStyles: {
                    cellPadding: 3,
                    lineWidth: 0.8,
                    valign: 'top',
                    fontStyle: 'bold',
                    halign: 'center',
                    fillColor: "white",
                    textColor: [0, 0, 0],
                    fontSize: 7,
                    rowHeight: 10,
                    lineColor: "black"
                },
                bodyStyles: {
                    columnWidth: 'wrap',
                    textColor: [30, 30, 30],
                    cellPadding: 3,
                    fontSize: 8,
                    lineColor: [6, 3, 1]
                },
                columnStyles: {
                    0: {
                        valign: "top",
                        columnWidth: 110
                    },
                    1: {
                        halign: 'right',
                        columnWidth: 60
                    },
                    2: {
                        halign: 'right',
                        columnWidth: 60
                    },
                    3: {
                        halign: 'right',
                        columnWidth: 60
                    },
                    4: {
                        halign: 'right',
                        columnWidth: 62
                    },
                    5: {
                        halign: 'right',
                        columnWidth: 62
                    },
                    6: {
                        halign: 'right',
                        columnWidth: 63
                    },

                    7: {
                        halign: 'right',
                        columnWidth: 63
                    },

                },


                margin: {
                    left: margin.left,
                    bottom: margin.bottom,
                    top: margin.top,
                },


                didParseCell: (data1) => {

                    if (data1.row.cells[0].raw === "Invoice Total") {
                        data1.row.cells[0].styles.fontSize = 8;
                        data1.row.cells[0].styles.fontStyle = "bold";

                        data1.row.cells[1].styles.fontSize = 8;
                        data1.row.cells[1].styles.fontStyle = "bold";

                        data1.row.cells[2].styles.fontSize = 8;
                        data1.row.cells[2].styles.fontStyle = "bold";
                    }

                    if (data1.row.cells[3].raw === "Blank") {
                        data1.row.cells[2].colSpan = 2;
                        data1.row.cells[0].styles.fontSize = 8;
                        data1.row.cells[0].styles.fontStyle = "bold";
                    }

                    if (data1.row.cells[0].raw === "Invoice") {
                        data1.row.cells[0].styles.fontSize = 7;
                        data1.row.cells[0].styles.fontStyle = "bold";

                        data1.row.cells[1].styles.fontSize = 7;
                        data1.row.cells[1].styles.fontStyle = "bold";
                        data1.row.cells[1].styles.halign = "center";

                        data1.row.cells[2].styles.fontSize = 7;
                        data1.row.cells[2].styles.fontStyle = "bold";
                        data1.row.cells[2].styles.halign = "center";

                        data1.row.cells[3].styles.fontSize = 7;
                        data1.row.cells[3].styles.fontStyle = "bold";
                        data1.row.cells[3].styles.halign = "center";
                    }

                    if (data1.row.cells[3].raw === "Total Amount") {
                        data1.row.cells[2].colSpan = 2;
                    }

                    if (data1.row.cells[1].raw === "Date") {
                        data1.row.cells[0].colSpan = 3;
                        data1.row.cells[0].styles.fontSize = 8;
                        data1.row.cells[0].styles.fontStyle = "bold";
                    }


                    const boldHeaders = [
                        "Payment Mode1",
                        "Payment Mode1 Amount",
                        "Payment Mode2",
                        "Payment Mode2 Amount"
                    ];

                    if (boldHeaders.includes(data1.cell.raw)) {
                        data1.cell.styles.fontStyle = "bold";
                        data1.cell.styles.fontSize = 7;
                        data1.cell.styles.halign = "center";
                    }


                    // INVOICE PAYMENT MODE SUMMARY FULL-SPAN
                    if (data1.row.cells[0].raw === "Invoice Payment Mode Total") {

                        data1.row.cells[0].colSpan = 8;

                        Object.keys(data1.row.cells).forEach((key, index) => {
                            if (index > 0) {
                                data1.row.cells[key].hidden = true;
                            }
                        });

                        data1.row.cells[0].styles.halign = "center";
                        data1.row.cells[0].styles.fontStyle = "bold";
                        data1.row.cells[0].styles.fontSize = 8;
                        data1.row.cells[0].styles.fillColor = [230, 230, 230];
                    }


                    // FULL SPAN EMPTY ROW between Order & Invoice
                    if (data1.row.cells[0]?.raw === "___BLANK_FULL_ROW___") {

                        // span across all 8 columns
                        data1.row.cells[0].colSpan = 8;

                        // hide remaining cells
                        Object.keys(data1.row.cells).forEach((k, i) => {
                            if (i > 0) {
                                data1.row.cells[k].hidden = true;
                            }
                        });

                        // height increase for spacing
                        data1.row.height = 20;

                        // remove text & border style
                        data1.row.cells[0].text = "";
                        data1.row.cells[0].styles.fillColor = false;
                        data1.row.cells[0].styles.lineWidth = 0;
                    }
                    if (
                        data1.section === "body" &&
                        typeof data1.cell.raw === "string" &&
                        data1.cell.raw.includes("=")   // summary format check
                    ) {
                        data1.cell.colSpan = 8;                     // FULL width
                        data1.cell.styles.fontSize = 8;
                        data1.cell.styles.fontStyle = "bold";
                        data1.cell.styles.halign = "left";
                        data1.cell.styles.cellPadding = 3;
                    
                        data1.row.height = 12;                      // slim row
                    }
                    
                


                },


            });




            // Ensure correct positioning for the next section
            const remainingVSpace = doc.internal.pageSize.height - margin.bottom - doc.lastAutoTable.finalY;

            if (remainingVSpace > 25) {
                nextSection = currentSection;
                startY = doc.lastAutoTable.finalY;
            } else {
                startY = margin.top;
                if (nextSection === 1) doc.addPage();

            }

            const pageCount = doc.internal.getNumberOfPages();

            doc.setFont('helvetica', 'Normal');

            if ((data.length - 1) === tableIndex) {
                for (let i = 0; i <= pageCount; i++) {
                    doc.setPage(i);

                    style.pageBorder(doc);
                    style.pageHeder1(doc, tableData);
                    style.reportHeder3(doc, tableData);
                    // style.pageBorder(doc, tableData);

                    doc.setFont('helvetica', 'Normal');
                    doc.setFontSize(10);

                    doc.text('Print Date: ' + String(currentDate_dmy) + ' Time: ' + String(CurrentTime()), 30, 834);
                    // doc.text('Page ' + String(i) + ' of ' + String(pageCount), 500, 828);
                }
            }

        });

        // Delete the unused first empty page
        doc.deletePage(1);

        doc.setProperties({
            title: `POReport/${data[0].OrderDate}-${data[0].CustomerName}`
        });

        return doc;
    }

    // Function to generate, save and open the PDF report
    function generateSaveAndOpenPDFReport() {
        const pdfUrl = URL.createObjectURL(generatePDF().output('blob'));
        window.open(pdfUrl);
    }
    generateSaveAndOpenPDFReport();
}

export default ManagerSummaryReport;























